import {COLORS} from '@/styles/colors';

export const MENU_PROPS = {
  style: {
    height: '300px',
    width: '360px',
    top: '10px',
    left: '-34px',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
} as const;

export const SELECT_STYLE = {
  width: '114px',
  height: '56px',
  borderRadius: '10px',
  '&.Mui-focused:has(div[aria-expanded="false"])': {
    fieldset: {
      display: 'block',
    },
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: COLORS.ON_SURFACE_1,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: COLORS.ON_OUTLINE_LIGHT,
  },
  // Update default spacing
  '.MuiSelect-select': {
    padding: '8px',
    paddingRight: '24px !important',
  },
  '.MuiSelect-icon': {
    fontSize: '32px',
  },
  svg: {
    right: 0,
  },
} as const;
